import * as api from '@amzn/ring-cs-chatbot-service-model';

export type SessionOnConnectionEstablishedParams = {
    handler: () => void;
};
export type SessionOnConnectionBrokenParams = {
    handler: () => void;
};
export type SessionOnMessageParams = {
    handler: (message: api.ResponseMessage) => void;
};
export type SessionOnEndedParams = {
    handler: () => void;
};

export enum SessionStatus {
    CREATED,
    CONNECTING,
    ESTABLISHED,
    BROKEN,
    ENDED,
}

export type SessionStatusHandler = (status: SessionStatus) => void;

export type SendMessageRequest = Omit<api.SendMessageRequest, 'sessionId'>;
export type TranscriptRequest = Omit<api.TranscriptRequest, 'sessionId'>;

export interface Session {
    connect: () => Promise<void>;
    sendMessage: (params: SendMessageRequest) => Promise<api.SendMessageResponse>;
    transcript: (params: TranscriptRequest) => Promise<api.TranscriptResponse>;
    end: () => Promise<void>;
    clear: () => void;

    onStatusUpdate: (handler: SessionStatusHandler) => (() => void);
    onConnectionEstablished: (params: SessionOnConnectionEstablishedParams) => void;
    onConnectionBroken: (params: SessionOnConnectionBrokenParams) => void;
    onMessage: (params: SessionOnMessageParams) => void;
    onEnded: (params: SessionOnEndedParams) => void;

    getAttributes: () => Record<string, string>;
    getSessionId: () => string | undefined;
}
